module.exports = __webpack_public_path__ + "static/img/giantscausway.c12ea29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/GeographyMasthead/images/giantscausway.jpg
// module id = scHf
// module chunks = 1